import React from 'react'
import classnames from 'classnames/bind'

import Layout from 'components/shared/Layout'
import Image from 'components/shared/Image'
import LabelTitleText from 'components/shared/LabelTitleText'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const Hero = ({
  className,
  withTopBackgroundImage,
  topRightBackgroundImage,
  bottomLeftBackgroundImage,
  intro,
  forwardRef,
  children,
  smallAssets,
}) => {
  const topImage = topRightBackgroundImage || {
    media: { width: 685, height: 539 },
    src: '/assets/use-case/hero-background-top.svg',
    alt: 'triangle shape',
  }

  const bottomImage = bottomLeftBackgroundImage || {
    media: { width: 288, height: 352 },
    src: '/assets/use-case/hero-background-bottom.svg',
    alt: 'triangle shape',
  }
  return (
    <section ref={forwardRef} className={cx(css.Hero, className)}>
      <div className={css.background}>
        {topImage && withTopBackgroundImage && (
          <Image
            className={cx(css.heroBackgroundTop, { smallAssets })}
            {...topImage}
            priority
          />
        )}
      {bottomImage && (
      <Image className={css.heroBackgroundBottom} {...bottomImage} />
        )}
    </div>

    <Layout type="wrapper" className={css.heroWrapper}>
      <Layout type="innerWrapper">
        {intro && (
        <LabelTitleText
          titleProps={{
                theme: 'white',
                size: 'extra-large',
                tag: 'h1',
              }}
          textProps={{
                theme: 'white',
                className: css.text,
                tag: 'h2',
              }}
          textWithLinkProps={{
                theme: 'white',
              }}
          {...intro}
        />
          )}
        {children}
      </Layout>
    </Layout>
  </section>
  )
}

Hero.defaultProps = {
  withTopBackgroundImage: true,
}

export default Hero